<template>
    <main class="page" v-if="main">
        <!-- Banner -->
        <motor-banner :bgimg="{
            src: env.imageUrl + main.banner.banner_contact.image,
            loading: env.imageUrl + main.banner.banner_contact.thumb_image,
        }" title="contact us" />
        <!-- Section -->
        <section class="section section--contact">
            <div class="motor-container">
                <article class="quick-contact">
                    <div class="quick-box phone">
                        <div>
                            <h2>Call Us</h2>
                            <a target="_blank" :href="'tel:' + main.contact.phone">{{main.contact.phone}}</a>
                        </div>
                    </div>
                    <div class="quick-box address">
                        <div>
                            <h2>Where To Find Us</h2>
                            <a target="_blank" :href="main.contact.address_url">{{main.contact.address}}</a>
                        </div>
                    </div>
                    <div class="quick-box mail">
                        <div>
                            <h2>Write To Us</h2>
                            <a target="_blank" :href="'mailto:' + main.contact.email">{{main.contact.email}}</a>
                        </div>
                    </div>
                </article>
                <form @submit.prevent="postMessage" class="contact-form">
                    <input type="text" placeholder="Name" 
                        :class="{'danger': error.name}" 
                        @keyup="onChange('name')"
                        v-model="user.name">
                    <input type="number" placeholder="Phone"
                        :class="{'danger': error.phone}" 
                        @keyup="onChange('phone')"
                        v-model="user.phone">
                    <input type="email" placeholder="Email"
                        :class="{'danger': error.email}" 
                        @keyup="onChange('email')"
                        v-model="user.email">
                    <input type="text" placeholder="Subject"
                        @keyup="onChange('subject')"
                        v-model="user.subject">
                    <textarea rows="12" placeholder="Message" v-model="user.message"></textarea>
                    <div class="button-container">
                        <button :disabled="posting" class="button--motor">send</button>
                    </div>
                    <div class="page-loading" :class="{show: posting}">
                        <div class="loading--icon"></div>
                    </div>
                </form>
                <div class="success-message" v-if="message">{{message}}</div>
            </div>
        </section>
        <section class="section section--map" v-html="main.contact.map"></section>
        <!-- Footer -->
        <motor-footer :data="main" />
    </main>
    <main class="showroom-detail loading" v-else>
        <div class="loading--icon"></div>
    </main>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import { env } from '../enviorments'

import MotorBanner from '@/components/MotorBanner.vue'
import BannerImg from '@/assets/images/home-banner.jpg'

export default {
    name: 'contact',
    components: {
        MotorBanner,
    },
    data() {
        return {
            BannerImg,
            env,
            user: {
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: '',
            },
            error: {
                name: null,
                email: null,
                phone: null,
            },
            posting: false,
            message: '',
        }
    },
    computed: {
        ...mapState({
            main: state => state.main,
        })
    },
    methods: {
        ...mapActions({
            callMain: 'callMain',
        }),
        async postMessage() {
            console.log('SUBMIT')
            console.log(this.posting)
            if (this.onChange('name')) this.error.name = true
            if (this.onChange('email')) this.error.email = true
            if (this.onChange('phone')) this.error.phone = true
            if (this.error.name || this.error.email || this.error.phone) return
            this.posting = true
            const post = await this.postingToAPI()
            if (post) {
                this.message = 'Success!'
                this.reset()
            } else {
                this.message = 'Error occur! Please try again.'
            }
            this.posting = false
        },
        onChange(val) {
            this.posting = false
            this.message = ''
            if (val == "name") {
                this.error.name =
                    this.user.name && this.user.name.length > 3 ? false : true
            } else if (val == "email") {
                const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                this.error.email =
                    this.user.email && re.test(this.user.email.toLowerCase())
                        ? false
                        : true
            } else if (val == "phone") {
                const re = /^\d{8,15}$/
                this.error.phone =
                    this.user.phone && re.exec(this.user.phone)
                        ? false
                        : this.user.phone ? true: false
            }
        },
        async postingToAPI() {
            const data = (await this.axios.post(env.apiUrl + 'contactus-send', {...this.user})).data
            if (data.status) return true
            else return false
        },
        reset() {
            this.user = {
                name: '',
                email: '',
                phone: '',
                message: '',
            }
        }
    },
    async mounted() {
        if (!this.main) await this.callMain()
        console.log(this.main, this.home)
    }
}
</script>

<style lang="scss" scoped>
.page {
    .section--contact {
        padding: 40px 0;
        .motor-container {
            @media (min-width: 768px) {
                display: flex;
                flex-wrap: wrap;
            }
            .success-message {
                width: 100%;
                padding: 20px;
                font-size: 2rem;
                color: var(--primary);
                font-weight: 300;
                text-align: center;
            }
            .quick-contact {
                padding: 10px;
                @media (min-width: 768px) {
                    flex: 1;
                }
                .quick-box {
                    padding-bottom: 40px;
                    display: flex;
                    align-items: center;
                    &::before {
                        content: '';
                        display: block;
                        width: 40px;
                        height: 40px;
                        // background-color: var(--primary);
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-position: center;
                        margin-right: 5px;
                    }
                    h2 {
                        font-weight: 300;
                        padding: 0;
                        line-height: 1em;
                        @media (min-width: 768px) {
                            font-size: 1.6rem;
                        }
                        @media (min-width: 992px) {
                            font-size: 1.8rem;
                        }
                    }
                    a {
                        text-decoration: none;
                        color: #666;
                    }
                    &.phone::before {
                        background-image: url(../assets/icons/c4.png);
                    }
                    &.address::before {
                        background-image: url(../assets/icons/c2.png);
                    }
                    &.mail::before {
                        background-image: url(../assets/icons/c3.png);
                    }
                }
            }
            .contact-form {
                padding: 0;
                position: relative;
                @media (min-width: 768px) {
                    flex: 1;
                }
                @media (min-width: 992px) {
                    flex: 2;
                }
                .page-loading {
                    position: absolute;
                    z-index: 9;
                    top: 0; right: 0;
                    bottom: 0; left: 0;
                    background-color: #fff9;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    opacity: 0;
                    pointer-events: none;
                    transition: opacity .3s ease;
                    &.show {
                        opacity: 1;
                        pointer-events: auto;
                    }
                }
                input,
                textarea {
                    width: calc(100% - 20px);
                    border: 1px solid #999;
                    border-radius: 5px;
                    padding: 12px;
                    outline: none;
                    resize: none;
                    margin: 10px;@media (min-width: 992px) {
                        margin: 20px 10px;
                    }
                    &.danger {
                        border-color: #f00;
                    }
                }
                input {
                    @media (min-width: 992px) {
                        width: calc(50% - 20px);
                    }
                }
                .button-container {
                    display: flex;
                    justify-content: flex-end;
                    padding: 10px;
                    .button--motor {
                        &:disabled {
                            opacity: .5;
                        }
                    }
                }
            }
        }
    }
}
</style>
